import { render, staticRenderFns } from "./TNOSWaitingList.vue?vue&type=template&id=87eb3f74"
import script from "./TNOSWaitingList.vue?vue&type=script&lang=js"
export * from "./TNOSWaitingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports